import { FieldActivityType, LeaveType } from "@core/models/enums";
import { LOCAL_STORAGE_KEY, SESSION_STORAGE_KEY } from "@core/configs";
import { environment } from "@environments/environment";
import { Utils, convertToHiragana } from "@core/helper";
import { cloneDeep } from "lodash";
import { BATH_SCREEN, KbnStatus, LIST_PERIOD_CONSTANT, Mode, OfficeType, PERIOD_CONSTANT } from "@core/constants";
import moment from "moment";
import { v4 } from "uuid";
import { UserDashboardSreenSetting } from "@modules/user-dashboard/user-dashboard-setting-dialog/user-dashboard-setting.model";
import { BatheHelper } from "@modules/bathe-management/bathe.helper";
import { BatheType } from "@core/models/models";

export class CommonHelper {
  public static arrayChunk(inputArray: any[], size = 10): any[] {
    return inputArray.reduce((resultArray, item, index) => {
      const chunkIndex = Math.floor(index / size);

      if (!resultArray[chunkIndex]) {
        resultArray[chunkIndex] = []; // start a new chunk
      }
      resultArray[chunkIndex].push(item);

      return resultArray;
    }, []);
  }

  // cập nhật trạng thái isWarning cho user, clear data đối với user is leave
  public static processUserData(data: any[], officeType: number = OfficeType.newTsusho, lstDaiInfo?: any[], isHighlightRecord: boolean = true, isCheckSheetScreen: boolean = false, screenAlias: string = ""): any[] {
    if (!data) return [];
    let dataReturn = data.map(item => {
      // Tạo 1 index giả để đặt giá trị khi có user Nghỉ.
      item.index = 0;
      // Nếu day_care có thuộc tính `resultatr = 3` clear data
      if (item?.day_care?.resultatr == 3) {
        return Object.keys(item).reduce((acc, key) => {
          // Lấy giá trị hiện tại của key
          const value: any = item[key]; 
  
          switch (key) {
            case 'user':
              // Nếu user có thuộc tính `isWarning`, đặt lại thành `false`
              acc[key] = { ...value, isWarning: false };
              break;
            case 'index':
              // Nếu là key `index`, đặt giá trị bằng 休
              acc[key] = { value: LeaveType.leave };
              break;
            case 'day_care':
              // giữ nguyên
              acc[key] = { ...value };
              break;
            case 'leave_reason':
              acc[key] = { ...value };
              break;
            case 'notice_list':
              // giữ nguyên
              acc[key] = [...item?.leave_reason];
              break;
            default:
              // Nếu là mảng -> gán thành mảng rỗng `[]`
              if (Array.isArray(value)) {
                acc[key] = [];
              } 
              // Nếu là object (không phải null) -> gán thành object rỗng `{}`
              else if (typeof value === 'object' && value !== null) {
                acc[key] = {};
              } 
              // Nếu là số, chuỗi, boolean -> gán thành `null`
              else {
                acc[key] = null;
              }
          }

          return acc;

          // Khởi tạo object rỗng ban đầu
        }, {} as any);
      }
      if (isCheckSheetScreen || screenAlias == BATH_SCREEN.SCREEN_ALIAS) {
        const bypassFields = ['user','index','notice_list','day_care'];
        if(screenAlias == BATH_SCREEN.SCREEN_ALIAS) {
            bypassFields.push('bathe');
            bypassFields.push('bathe_method');
        }
        Object.keys(item).forEach((prop) => {
          let value: any = item[prop];

          // Skip các field không cần lọc

          if (bypassFields.includes(prop)) return;

          item[prop] = CommonHelper.filterByTodayJP(value);
        });
      }
      if(Utils.isNyusho(officeType) && isCheckSheetScreen) {
        // đối ứng task ăn bằng ống nyusho (CKWEB-587)
        if (Array.isArray(item?.enteral_feeding) && item?.enteral_feeding?.length > 0) {
          // Ensure item.meal is an array before spreading
          const mealArray = Array.isArray(item?.meal) ? item.meal : (item?.meal ? [item.meal] : []);
          item.meal = [...mealArray, ...item?.enteral_feeding];
          
          // Ensure item.meal_moisture is an array before spreading
          const mealMoistureArray = Array.isArray(item?.meal_moisture) ? item.meal_moisture : (item?.meal_moisture ? [item.meal_moisture] : []);
          let mealMoiFeedingLst = [...mealMoistureArray, ...item?.enteral_feeding];
          let mergedMealMoiFeeding:any = {};
          mealMoiFeedingLst?.forEach(item => {
            if (!mergedMealMoiFeeding[item.noteid]) {
              mergedMealMoiFeeding[item.noteid] = { ...item }; // nếu chưa có thì copy vô
            } else {
              Object.assign(mergedMealMoiFeeding[item.noteid], item); // nếu có rồi thì gộp lại
            }
          });
          let mergedMoiFeedingLst = Object.values(mergedMealMoiFeeding);
          if (mergedMoiFeedingLst?.length > 0) item.meal_moisture = mergedMoiFeedingLst;
        }
        // Đối ứng task CKWEB-777 nếu không tìm thấy noteid thì lượng nước để rỗng.
        if (item?.meal?.length > 0) {
          item?.meal?.forEach((meal:any) => {
            let findMoi:any = item?.meal_moisture?.find((x:any)=>x.noteid == meal.noteid);
            if (!findMoi) {
              item?.meal_moisture?.push(
                {
                  noteid: meal?.noteid,
                  moisture: "",
                  date: meal?.date,
                  attention_flg: meal?.attention_flg
                }
              );
            }
          });
        }
      }
      else if(Utils.isTsusho(officeType) && isCheckSheetScreen){
        if (item?.enteral_feeding && item?.meal) {
          let feedingByPeriod = this.filterLatestByPeriod(item?.enteral_feeding);
          if (feedingByPeriod?.length > 0) {
            const mealDate = moment(item?.meal?.date);
            const feedingDate = moment(feedingByPeriod[0]?.date);
            if(feedingDate.isAfter(mealDate)){
              item.meal.isfeeding = true;
              item.meal.feeding_attention_flg = feedingByPeriod[0]?.attention_flg ?? false;
            } else {
              item.meal.isfeeding = false;
            }
          }
        }
        // đối ứng task ăn bằng ống tsusho (CKWEB-587)
        else if (item?.enteral_feeding) {
          if (!item?.meal) item.meal = {};
          let feedingByPeriod = this.filterLatestByPeriod(item?.enteral_feeding);
          item.meal.isfeeding = feedingByPeriod?.length > 0;
          item.meal.feeding_attention_flg = feedingByPeriod?.[0]?.attention_flg ?? false;
        }
      }
      
      // kiểm tra attention_list có data hay không
      const hasAttentionList = item.attention_list && Array.isArray(item.attention_list) && item.attention_list.length > 0;
      if (item.index.length === 0) {
        item.index = {
          value: LeaveType.leave,
          isWarning: hasAttentionList,
          isHighlightRecord: isHighlightRecord
        };
      }
      if (item.moisture && Array.isArray(item.moisture)) {
        item.moistureArr = item.moisture;
        let totalVolume = 0;
        item.moisture.map((m:any) => m.volume).forEach((v:any) => totalVolume += v);
        item.moisture = totalVolume; 
      }
      if (item.medicine_list && Array.isArray(item.medicine_list)) {
        item.medicine_list = item.medicine_list.map((x:any) => ({
          ...x,
          type: Utils.isNyusho(officeType) ? 4 : 0
        }));
        if(Utils.isTsusho(officeType)) {
          item.excretion_list = [
            ...(item.excretion_list || []), 
            ...(item.medicine_list || [])
          ];
        }
      }
      // Map daiCd for each item in excretion_list
      if (item.excretion_list && Array.isArray(item.excretion_list)) {
        item.excretion_list = item.excretion_list.map((excretionItem: any) => ({
          ...excretionItem,
          daiCd: item.user?.daicd
        }));
      }
      // Filter bathe record for checksheet screen
      let tempBathe = item?.bathe ?? [];
      if(Array.isArray(item?.bathe) && item?.bathe.length > 0 && screenAlias != BATH_SCREEN.SCREEN_ALIAS) {
        tempBathe = this.getLastestBathItem(item);
      }

      return {
        // Giữ nguyên dữ liệu cũ
        ...item, 
        bathe: tempBathe,
        index:{
            index: item + 1,
            isWarning: hasAttentionList ? true : false,
            isHighlightRecord: item.isHighlightRecord
        },
        user: {
          // Đảm bảo `user` luôn là object hợp lệ
          ...(item.user && typeof item.user === "object" ? item.user : {}), 
          // Nếu có `attention_flg = true`, gán `isWarning = true`
          isWarning: hasAttentionList ? true : false,
          isHighlightRecord: isHighlightRecord
        }
      };
    });

    if (!lstDaiInfo) {
        let value = sessionStorage.getItem(SESSION_STORAGE_KEY.daiInfo) || "";
        lstDaiInfo = JSON.parse(value);
    }

    lstDaiInfo = lstDaiInfo || [];

    dataReturn = dataReturn.filter(item => {
        if (lstDaiInfo?.length > 0) {
          let daiObj = lstDaiInfo.find((x: any) => x.daicd === item?.user?.daicd);
          // Cập nhật thông tin Dai
          if (daiObj) {
            item.user.face_img = !Utils.isNullOrEmpty(daiObj.avatarSource) ? environment.avatarUrl + "/" + daiObj.avatarSource : "";
            item.user.family = daiObj.family;
            item.user.given = daiObj.given;
            item.user.kanafamily = daiObj.kanafamily;
            item.user.kanagiven = daiObj.kanagiven;
            item.user.sex = daiObj.sex;
            item.user.roomcd = daiObj.roomcd;
            item.user.roomnm = daiObj.roomnm;
            item.user.unitobjcd = daiObj.unitobjcd;
            item.user.bedcd = daiObj.bedcd;
            item.room_name = this.formatRoomName(item.user.roomnm);

            return true; // Giữ lại item trong mảng
          }
        }
      return false; // Loại bỏ item nếu không tìm thấy daiObj
    });
    return dataReturn;
  }

  private static getLastestBathItem(item: any) {

    const batheList = Array.isArray(item?.bathe) ? item.bathe : [];

    if (batheList.length === 0) {
      return {};
    }
    
    const bathe = item.bathe.reduce((priorityBathe: any, bathe: any) => {
      const priorityTime = new Date(priorityBathe?.date).getTime();
      const batheTime = new Date(bathe?.date).getTime();

      if (batheTime > priorityTime) return bathe;
      if (batheTime < priorityTime) return priorityBathe;
      //case They  has the same time, we will less priority for STATUS_SCHEDULE
      const shouldReplace =
        priorityBathe?.status_kbn === KbnStatus.STATUS_SCHEDULE &&
        bathe?.status_kbn !== KbnStatus.STATUS_SCHEDULE;

      return shouldReplace ? bathe : priorityBathe;
    }, item.bathe[0]); // get the first item
    return { ...bathe };
  }

  public static formatRoomName(roomnm: string = ''): string {
    if (!roomnm) return '';
    if (roomnm.length <= 6) return roomnm;
    return roomnm.substring(0, 6) + "…";
  }
  public static filterByTodayJP(data: any): any {
    let todayJP = new Date().toLocaleDateString('ja-JP', { timeZone: 'Asia/Tokyo' });
    if (Array.isArray(data)) {
      return data.filter(item => {
        let rawDate = item?.date || item?.time || item?.upddate;
        if (!rawDate) return false;
        let itemDateJP = new Date(rawDate).toLocaleDateString('ja-JP', { timeZone: 'Asia/Tokyo' });
        return itemDateJP === todayJP;
      });
    } else if (typeof data === 'object' && data !== null) {
      let rawDate = data?.date || data?.time || data?.upddate;
      if (!rawDate) return null;
      let itemDateJP = new Date(rawDate).toLocaleDateString('ja-JP', { timeZone: 'Asia/Tokyo' });
      return itemDateJP === todayJP ? data : null;
    }

    return data;
  }
  public static formatDateForArrayData(data: any[]) {
    if(!data || data.length == 0) return [];

    return data.map(dt => {
      dt.date = new Date(dt.date?.replace(/(\d{4}-\d{2}-\d{2})(\d{2}:\d{2})/, "$1 $2"))
      return dt;
    })
    // Loại bỏ các phần tử có date là null
    .filter(dt => dt.date !== null)
    // Sắp xếp giảm dần
    .sort((a, b) => b.date.getTime() - a.date.getTime());
  }

  // sort data theo kananame
  public static sortDataByKanaName(arrData: any[], isSortByRoom: boolean, tokenizer: any, onGroupping: boolean, allowAttention: boolean = true, isHighlightRecord: boolean = true, mustRemoveLeaveUser: boolean = false) {
    try{
    if (!Array.isArray(arrData) || arrData.length === 0) {
      return;
    }
    if (onGroupping) {
      let dataFinal: any = [];
      const objGroup: { [key: string]: any[] } = {};
      for (const item of arrData) {
        const grNm = item.groupName;
        if (!objGroup[grNm]) {
          objGroup[grNm] = [];
        }
        objGroup[grNm].push(item);
      }
      
      const groupedArray = Object.keys(objGroup).map(groupName => ({
        groupName,
        items: objGroup[groupName]
      }));
      let lstNotLeave, lstLeave;
      groupedArray.forEach(groupData => {
        // Sort lại data cho từng group.
        groupData.items.sort((a, b) => {
            const nameA = `${convertToHiragana(a.user.kanafamily, tokenizer)}${convertToHiragana(a.user.kanagiven, tokenizer)}`;
            const nameB = `${convertToHiragana(b.user.kanafamily, tokenizer)}${convertToHiragana(b.user.kanagiven, tokenizer)}`;
            return nameA.localeCompare(nameB, 'ja');
        });
        // Tách riêng các phần tử có index === "休" và các phần tử còn lại
        lstNotLeave = groupData?.items?.filter((item: any) => item?.index?.value !== LeaveType.leave);
        lstLeave = mustRemoveLeaveUser ? [] : groupData?.items?.filter((item: any) => item?.index?.value === LeaveType.leave);
        dataFinal = [...dataFinal, ...lstNotLeave, ...lstLeave];
      });
      return dataFinal;
    } else {
      // Tách riêng các phần tử có index === "休" và các phần tử còn lại
      let itemsWithoutLeave = arrData.filter(item => item.index?.value !== LeaveType.leave);
      let itemsWithLeave = mustRemoveLeaveUser ? [] : arrData.filter(item => item.index?.value === LeaveType.leave);
      itemsWithoutLeave.sort((a, b) => {
        if (isSortByRoom) {
          const unitA = a.user?.unitobjcd?.toString() ?? '';
          const unitB = b.user?.unitobjcd?.toString() ?? '';
          const unitCompare = unitA.localeCompare(unitB, 'ja');
          if (unitCompare !== 0) return unitCompare;

          const roomA = a.user?.roomcd?.toString() ?? '';
          const roomB = b.user?.roomcd?.toString() ?? '';
          const roomCompare = roomA.localeCompare(roomB, 'ja');
          if (roomCompare !== 0) return roomCompare;

          const bedA = a.user?.bedcd?.toString() ?? '';
          const bedB = b.user?.bedcd?.toString() ?? '';
          return bedA.localeCompare(bedB, 'ja');
        } else {
          const nameA = `${convertToHiragana(a.user.kanafamily, tokenizer)}${convertToHiragana(a.user.kanagiven, tokenizer)}`;
          const nameB = `${convertToHiragana(b.user.kanafamily, tokenizer)}${convertToHiragana(b.user.kanagiven, tokenizer)}`;
          return nameA.localeCompare(nameB, 'ja');
        }
      });
      // Đánh số lại index cho itemsWithoutLeave
      itemsWithoutLeave = itemsWithoutLeave.map((item, index) => {
      let hasAttentionList = false;
      if(allowAttention) {
        hasAttentionList = (CommonHelper.filterByTodayJP(item?.attention_list ?? [])?.length ?? 0) > 0; 
      }
      return {
        ...item,
        index: {
          value: index + 1,
          isWarning: hasAttentionList,
          isHighlightRecord: isHighlightRecord
        }
      };
    });
      // Gộp lại danh sách
      return [...itemsWithoutLeave, ...itemsWithLeave];
    }
    }
    catch(ex)
    {
      console.log(ex)
    }
  }

  public static sortDataBySortNo(
      arrData: any[], 
      allowAttention: boolean = true, 
      isHighlightRecord: boolean = true, 
      mustRemoveLeaveUser: boolean = false, 
      isNyusho: boolean = false,
      tokenizer:any,
      bathDailyRoomSet?: Set<string>
    ) {
    if (!Array.isArray(arrData) || arrData.length === 0) {
      return;
    }
    // Tách riêng các phần tử có index === "休" và các phần tử còn lại
    let itemsWithoutLeave = arrData.filter(item => item.index?.value !== LeaveType.leave);
    let itemsWithLeave = mustRemoveLeaveUser ? [] : arrData.filter(item => item.index?.value === LeaveType.leave);

    //group theo bathRoomCd
    const group = new Map<string, any[]>();

    itemsWithoutLeave.forEach(item => {
      const bathRoomCd = item.bathRoomCd ?? '';
      if (!group.has(bathRoomCd)) {
        group.set(bathRoomCd, []);
      }
      const list = group.get(bathRoomCd);
      if (list) {
        list.push(item);
      }
    });

    let sortedResult: any[] = [];

    group.forEach((list, bathRoomCd) => {
      const hasBathDaily = bathDailyRoomSet?.has(bathRoomCd);
      if (hasBathDaily) {
        sortedResult.push(
          ...this.sortByBathRoomNmAndSortNo(list)
        );
      } else {
        sortedResult.push(
          ...this.sortByPriorityAndYoteiData(list, isNyusho, tokenizer)
        );
      }
    });
    // Đánh số lại index cho itemsWithoutLeave
    itemsWithoutLeave = itemsWithoutLeave.map((item, index) => {
      let hasAttentionList = false;
      if (allowAttention) {
        hasAttentionList = (CommonHelper.filterByTodayJP(item?.attention_list ?? [])?.length ?? 0) > 0;
      }
      return {
        ...item,
        index: {
          value: index + 1,
          isWarning: hasAttentionList,
          isHighlightRecord: isHighlightRecord
        }
      };
    });
    // Gộp lại danh sách
    return [...itemsWithoutLeave, ...itemsWithLeave];
  }

  public static sortByBathRoomNmAndSortNo(arrData: any[]) {
    arrData?.sort((a: any, b: any) => {
      const blockA = a.user?.blockcd ?? '';
      const blockB = b.user?.blockcd ?? '';

      const unitA = a.user?.unitcd ?? '';
      const unitB = b.user?.unitcd ?? '';

      const bathA = a.bathRoomName ?? '';
      const bathB = b.bathRoomName ?? '';

      const sortA = String(a.sortNo ?? 9999).padStart(4, '0');
      const sortB = String(b.sortNo ?? 9999).padStart(4, '0');

      const keyA = `${blockA}-${unitA}-${bathA}-${sortA}`;
      const keyB = `${blockB}-${unitB}-${bathB}-${sortB}`;

      if (keyA > keyB) return 1;
      if (keyA < keyB) return -1;
      return 0;
    });
    return arrData;
  }

  public static sortByPriorityAndYoteiData(arrData: any[], isNyusho: boolean, tokenizer: any) {
    if (isNyusho) {
      arrData?.sort((a: any, b: any) => {
        const bathA = a.bathRoomName ?? '';
        const bathB = b.bathRoomName ?? '';

        const priorityA = BatheHelper.PRIORITY_ORDER[a.priorityCd ?? BatheType.None] ?? 999;
        const priorityB = BatheHelper.PRIORITY_ORDER[b.priorityCd ?? BatheType.None] ?? 999;

        const blockA = a.user?.blockcd ?? '';
        const blockB = b.user?.blockcd ?? '';

        const unitA = a.user?.unitcd ?? '';
        const unitB = b.user?.unitcd ?? '';

        const roomA = a.user?.roomcd ?? '';
        const roomB = b.user?.roomcd ?? '';

        const bedA = a.user?.bedcd ?? '';
        const bedB = b.user?.bedcd ?? '';

        const groupA = `${bathA}-${blockA}-${unitA}`;
        const groupB = `${bathB}-${blockB}-${unitB}`;

        const keyA = `${groupA}-${priorityA}-${roomA}-${bedA}`;
        const keyB = `${groupB}-${priorityB}-${roomB}-${bedB}`;

        if (keyA > keyB) return 1;
        if (keyA < keyB) return -1;
        return 0;
      });
    } else {
      arrData?.sort((a: any, b: any) => {
        const bathA = a.bathRoomName ?? '';
        const bathB = b.bathRoomName ?? '';

        const priorityA = BatheHelper.PRIORITY_ORDER[a.priorityCd ?? BatheType.None] ?? 999;
        const priorityB = BatheHelper.PRIORITY_ORDER[b.priorityCd ?? BatheType.None] ?? 999;

        const nameA = `${convertToHiragana(a.user?.kanafamily ?? '', tokenizer)}${convertToHiragana(a.user?.kanagiven ?? '', tokenizer)}`;
        const nameB = `${convertToHiragana(b.user?.kanafamily ?? '', tokenizer)}${convertToHiragana(b.user?.kanagiven ?? '', tokenizer)}`;

        const keyA = `${bathA}-${priorityA}-${nameA}`;
        const keyB = `${bathB}-${priorityB}-${nameB}`;

        if (keyA > keyB) return 1;
        if (keyA < keyB) return -1;
        return 0;
      });
    }

    return arrData;
  }

  public static currentTimeInPeriod() {
    let timeFrame: any[] = ['0:00～10:59','11:00～15:59','16:00～23:59'];
    const currentHour = new Date().getHours();
    let currentPeriod: string | null = null;

    // Xác định khoảng thời gian bữa ăn hiện tại
    for (const time of timeFrame) {
        const [start, end] = time?.split('～')?.map((time: any) => parseInt(time.split(':')[0], 10));
        if (currentHour >= start && currentHour <= end) {
          currentPeriod = time;
          break;
        }
    }

   return currentPeriod;
  }

  public static getCurrentPeriod() {
    let timeFrame: any[] = LIST_PERIOD_CONSTANT;
    const currentHour = new Date().getHours();
    let currentPeriod: any = null;
    // Xác định khoảng thời gian period hiện tại
    for (const time of timeFrame) {
      const start = parseInt(time.START.split(':')[0], 10);
      const end = parseInt(time.END.split(':')[0], 10);
      if (currentHour >= start && currentHour <= end) {
        currentPeriod = time;
        break;
      }
    }
    return currentPeriod;
  }

  public static getPeriodByDate(date: string) {
    let timeFrame: any[] = LIST_PERIOD_CONSTANT;
    const currentHour = new Date(date).getHours();
    // Luôn luôn lấy start của buổi sáng làm giờ bắt đầu.
    const startHour = parseInt(PERIOD_CONSTANT.MORNING.START.split(':')[0], 10);
    let period: any = null;
    // Xác định khoảng thời gian period hiện tại
    for (const time of timeFrame) {
      const end = parseInt(time.END.split(':')[0], 10);
      if (currentHour >= startHour && currentHour <= end) {
        period = time;
        break;
      }
    }
    return period;
  }

  // Truyền vào 1 arr filter chỉ lấy item có giờ gần nhất theo period.
  public static filterLatestByPeriod(arr: any[]) {
    const todayStr = moment().format('YYYY-MM-DD');
    // Chỉ lấy data hôm nay.
    const todayItems = arr.filter(item => moment(item.date).format('YYYY-MM-DD') === todayStr);

    const result: any[] = [];
    
    todayItems.forEach(item => {
      const itemPeriod = this.getPeriodByDate(item.date);
      // Tìm index thuộc period giống nhau.
      const index = result.findIndex(r => this.getPeriodByDate(r.date) === itemPeriod);
      // Nếu không tìm thấy thì push thẳng vào mảng.
      if (index === -1) {
        result.push(item);
      } else {
        // Nếu tìm thấy thì check xem nếu là giờ gần nhất thì thay thế cái cũ.
        if (moment(item.date).isAfter(result[index].date)) {
          result[index] = item;
        }
      }
    });
  
    return result;
  }

  // Truyền vào 1 arr filter chỉ lấy item có giờ gần nhất theo period của hôm nay và hôm qua.
  public static filterPeriodTodayAndYesterday(arr: any[]) {
    const todayStr = moment().format('YYYY-MM-DD');
    const yesterdayStr = moment().subtract(1, 'day').format('YYYY-MM-DD');

    // Chỉ lấy data của hôm nay và hôm qua.
    const filteredItems = arr.filter(item => {
      const itemDateStr = moment(item.date).format('YYYY-MM-DD');
      return itemDateStr === todayStr || itemDateStr === yesterdayStr;
    });

    const result: any[] = [];

    filteredItems.forEach(item => {
      const itemPeriod = this.getPeriodByDate(item.date);
      const itemDay = moment(item.date).format('YYYY-MM-DD');

      // Tìm phần tử trong result có cùng ngày + period
      const index = result.findIndex(r =>
        this.getPeriodByDate(r.date) === itemPeriod &&
        moment(r.date).format('YYYY-MM-DD') === itemDay
      );

      // Nếu chưa có thì thêm vào
      if (index === -1) {
        result.push(item);
      } else {
        // Nếu có rồi thì lấy cái có giờ mới nhất
        if (moment(item.date).isAfter(result[index].date)) {
          result[index] = item;
        }
      }
    });

    return result;
  }


  public static getArrayData(data: any) {
    let arrayData: any[] = [];
    if (data && Array.isArray(data)) {
      if (data.length > 0) {
        arrayData = cloneDeep(CommonHelper.formatDateForArrayData(cloneDeep(data)));
      }
    }
    return arrayData;
  }

  public static filterExcretionByType(excretionList: any[]): any[] {
    if (!excretionList || excretionList.length == 0) return excretionList;
    let lstNodeID = excretionList.filter((item: any) => item?.type == FieldActivityType.NO_EXCRETION)
      .map((item: any) => item.noteid);
    if (!lstNodeID) return excretionList;
    let excretionListfilter = excretionList?.filter((item: any) =>
      !lstNodeID.includes(item?.noteid)
      || (item?.type != FieldActivityType.URINATION && item?.type != FieldActivityType.DEFECATION)
    )
    return excretionListfilter
  }

  public static getUtcTimestamp(): string {
    const now = new Date();
    const yyyy = now.getUTCFullYear();
    const MM = String(now.getUTCMonth() + 1).padStart(2, '0');
    const dd = String(now.getUTCDate()).padStart(2, '0');
    const HH = String(now.getUTCHours()).padStart(2, '0');
    const mm = String(now.getUTCMinutes()).padStart(2, '0');
    const ss = String(now.getUTCSeconds()).padStart(2, '0');
    const fff = String(now.getUTCMilliseconds()).padStart(3, '0');

    return `${yyyy}${MM}${dd}${HH}${mm}${ss}${fff}`;
  }

  public static generateSessionFirebaseID(deviceId: string = ''): string {
    if (!deviceId) {
    const chars = 'abcdefghijklmnopqrstuvwxyz';
      const randomChar = chars.charAt(Math.floor(Math.random() * chars.length));
      // YYYYMMDDHHmmss + randomChar(a-z)
      return `${moment().format('YYYYMMDDHHmmss')}${randomChar}`;
    } else {
      return `tv|${deviceId}`;
    }

  } 

  // get config by office common
  public static getScreenConfigByOfficeCd(storageKey: string = LOCAL_STORAGE_KEY.settingDialog): any {
    let officeInfo = sessionStorage.getItem(SESSION_STORAGE_KEY.selectedOfficeIdentity) || '';
    if (!officeInfo) return null;
    let officeCd = JSON.parse(officeInfo).officeCd;
    let allSettingsInfo = localStorage.getItem(storageKey);
    let allSettings = allSettingsInfo ? JSON.parse(allSettingsInfo) : {};  
    if(allSettings[officeCd] != null){
      CommonHelper.ensureUserDashboardSettings(allSettings[officeCd]); //add missing default settings before use
      allSettings[officeCd].userDashboardSettings.handOverSetting.handOverTotalDayOptions = [3, 4, 5, 6, 7]
      if(allSettings[officeCd].userDashboardSettings.handOverSetting.currentConfigValue == 1
        || allSettings[officeCd].userDashboardSettings.handOverSetting.currentConfigValue == 2)
        allSettings[officeCd].userDashboardSettings.handOverSetting.currentConfigValue = 3;
    }
      
    return allSettings[officeCd] || null;
  }

  // save config by office common
  public static setScreenConfigByOfficeCd(data: any, mode: Mode = Mode.WEB, storageKey: string = LOCAL_STORAGE_KEY.settingDialog): any {
    let officeInfo = sessionStorage.getItem(SESSION_STORAGE_KEY.selectedOfficeIdentity) || '';
    if (!officeInfo) return null;
    let officeCd = JSON.parse(officeInfo).officeCd;
    let allSettingsInfo = localStorage.getItem(storageKey);
    let allSettings = allSettingsInfo ? JSON.parse(allSettingsInfo) : {};
    allSettings[officeCd] = {
      ...(allSettings[officeCd] || {}),
      ...data,
      userDashboardSettings: data.userDashboardSettings ? { ...data.userDashboardSettings } : new UserDashboardSreenSetting()
    };

    localStorage.setItem(storageKey, JSON.stringify(allSettings));
    if(mode == Mode.TV && (window as any).AndroidBridge?.onWebDialogSave){
      const allSettingsString = JSON.stringify(allSettings);
      (window as any).AndroidBridge.onWebDialogSave(allSettingsString);
    }
  }
  
  public static distinctObjects<T>(arr: T[]): T[] {
    const seen = new Set<string>();
    return arr.filter(item => {
        const key = JSON.stringify(
          item,
          Object.keys(item as any).sort()
        );
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
    });
  }
  public static encode(obj: any): string { return encodeURIComponent(btoa(JSON.stringify(obj))) }
  public static decode(str: string): any { return JSON.parse(atob(decodeURIComponent(str))) }

    /**
     * Generate random userId for avatar processing
     * Format: 4 random characters + 6-digit timestamp
     * @returns Random userId string (e.g., "aBcD123456")
     */
    static generateRandomUserId(): string {
        // Generate 4 random characters (uppercase and lowercase letters)
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
        let randomChars = '';
        for (let i = 0; i < 4; i++) {
            randomChars += chars.charAt(Math.floor(Math.random() * chars.length));
        }

        // Get last 6 digits of current timestamp
        const timestamp = Date.now().toString().slice(-6);

        return `${randomChars}${timestamp}`;
    }
    
  // Compare func sắp xếp tăng dần (asc)
  public static compareAsc(a: any, b: any): number {
    // So sánh a và b, trả về 1 nếu a > b
    if (a > b) return 1;
    // -1 nếu a < b,
    if (a < b) return -1;
    // và 0 nếu bằng nhau
    return 0;
  }
    private static ensureUserDashboardSettings(screenConfig: any): void {
    const defaultUserDashboardSettings = new UserDashboardSreenSetting();
    screenConfig.userDashboardSettings = screenConfig.userDashboardSettings || defaultUserDashboardSettings;
    screenConfig.userDashboardSettings.handOverSetting = screenConfig.userDashboardSettings.handOverSetting || defaultUserDashboardSettings.handOverSetting;
    screenConfig.userDashboardSettings.imageIntervalSetting = screenConfig.userDashboardSettings.imageIntervalSetting || defaultUserDashboardSettings.imageIntervalSetting;
    screenConfig.userDashboardSettings.carePlanIntervalSetting = screenConfig.userDashboardSettings.carePlanIntervalSetting || defaultUserDashboardSettings.carePlanIntervalSetting;
  }
}
